import React from "react";
import { StatusBadge, joinClasses } from "./ResultsPrimitives.jsx";

export default function RouteStatusNotice({ notice = null, routeStatus = null }) {
  if (!notice || notice.hidden) {
    return null;
  }

  const shouldRenderRouteStatus = Boolean(routeStatus && routeStatus.isHidden !== true && typeof routeStatus.label === "string" && routeStatus.label.trim());

  return (
    <div className={joinClasses(["route-map__empty", notice.className || ""]) } aria-live="polite">
      <div className="route-map__empty-head">
        {shouldRenderRouteStatus ? (
          <StatusBadge tone={routeStatus.tone || "neutral"}>
            {routeStatus.label || "Routage indisponible"}
          </StatusBadge>
        ) : null}
      </div>
      <strong>{notice.title || "Carte en attente"}</strong>
      <p>{notice.message || "Aucune information de carte n'est disponible pour cette sélection."}</p>
    </div>
  );
}